// App-Konfiguration für das gemeinsame UI-Kit (Master: design-system/kit/kit.master.js).
// NUR die bewussten Unterschiede zwischen Admin und Partner leben hier (MASTER.md):
//   bg          — Seitenhintergrund (Admin #f5f5f5, Partner #f7f7f8; Eigentümer-Vorgabe)
//   classPrefix — 'pp': das Kit hängt exakt die heutigen pp-*-Hooks der index.css an
//   statVariant — 'compact': dichte Kennzahl-Kachel (uppercase-Label, inkl. bg-Prop)
const KIT_CONFIG = { bg: '#f7f7f8', classPrefix: 'pp', statVariant: 'compact' };
export default KIT_CONFIG;
